(function () {
  'use strict';
  if (window.__bolodooCartFeeGuardV3) return;
  window.__bolodooCartFeeGuardV3 = true;
  window.__bolodooCartFeeGuardV2 = true;
  window.__bolodooWeddingDressFeeBinding = true;
  let busy = false;
  const feeHandles = new Set([
    'plus-size-custom-size-service-fee-dont-remove-it-if-you-choose-this-service',
    'rush-order-service-fee-dont-remove-it-if-you-choose-the-rush-service',
  ]);
  const groupOf = item => item.properties?.['_BND group'] || item.properties?.['_BND group ID'] || '';
  const isFee = item => feeHandles.has(item.handle || (item.url || '').split('/products/')[1]?.split('?')[0]);
  const url = endpoint => `${(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/')}cart${endpoint}`;
  const enqueue = action => {
    const job = (window.__bolodooCartMutationTail || Promise.resolve()).then(action, action);
    window.__bolodooCartMutationTail = job.catch(() => {});
    return job;
  };

  async function json(endpoint, body) {
    const response = await fetch(url(endpoint), body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
    } : { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to update your bag. Please try again.');
    const result = await response.json();
    if (result.errors || result.status >= 400) throw new Error(result.description || 'Unable to update your bag. Please try again.');
    return result;
  }

  function render(source, cart) {
    const parse = html => new DOMParser().parseFromString(html, 'text/html');
    if (source.matches('cart-drawer')) {
      const next = parse(cart.sections['cart-drawer']).querySelector('#CartDrawer');
      if (!next) throw new Error('Unable to refresh your bag. Please reload the page.');
      source.querySelector('#CartDrawer').innerHTML = next.innerHTML;
      source.classList.toggle('is-empty', cart.item_count === 0);
      source.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => source.close());
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && cart.sections['cart-icon-bubble']) bubble.innerHTML = parse(cart.sections['cart-icon-bubble']).querySelector('.shopify-section').innerHTML;
      source.open();
    } else {
      source.getSectionsToRender().forEach(section => {
        const html = cart.sections[section.section || section.id];
        const target = document.getElementById(section.id);
        if (!html || !target) return;
        const next = parse(html).querySelector(section.selector || '.shopify-section');
        const current = target.querySelector(section.selector) || target;
        if (next) current.innerHTML = next.innerHTML;
      });
    }
    document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart, source: 'bolodoo-cart-fee-guard' } }));
  }

  async function update(source, row, quantity) {
    busy = true;
    source.setAttribute('aria-busy', 'true');
    source.querySelectorAll('.quantity__button').forEach(button => { button.disabled = true; });
    try {
      await enqueue(async () => {
      const cart = await json('.js');
      const item = cart.items.find(line => line.key === row.dataset.bndKey) || cart.items.find(line => groupOf(line) === row.dataset.bndGroup && !isFee(line));
      if (!item || !groupOf(item)) throw new Error('Your bag has changed. Please reload the page and try again.');
      if (isFee(item)) return;
      const group = cart.items.filter(line => groupOf(line) === groupOf(item));
      if (group.filter(line => !isFee(line)).length !== 1) throw new Error('Unable to match the service fee. Please reload your bag.');
      const updates = Object.fromEntries(group.map(line => [line.key, quantity]));
      const sections = source.getSectionsToRender().map(section => section.section || section.id);
      const result = await json('/update.js', { updates, sections, sections_url: window.location.pathname });
      for (const key of Object.keys(updates)) {
        const after = result.items.find(line => line.key === key);
        if ((after?.quantity || 0) !== quantity) throw new Error('Your bag quantity could not be updated. Please reload and try again.');
      }
      render(source, result);
      });
    } catch (error) {
      const message = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
      if (message) message.textContent = error.message;
      const input = row.querySelector('.quantity__input');
      if (input) input.value = input.defaultValue;
    } finally {
      busy = false;
      source.setAttribute('aria-busy', 'false');
      source.querySelectorAll('.quantity__button').forEach(button => { button.disabled = false; });
    }
  }

  function intercept(event, control, quantity) {
    const row = control.closest('.cart-item');
    const source = control.closest('cart-drawer, cart-items');
    if (!row || !source || (!row.dataset.bndGroup && row.dataset.bndFee !== 'true')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || row.dataset.bndFee === 'true' || !Number.isInteger(quantity) || quantity < 0) return;
    const input = row.querySelector('.quantity__input');
    if (quantity > 0 && input?.max && quantity > Number(input.max)) return;
    update(source, row, quantity);
  }

  window.addEventListener('click', event => {
    const remove = event.target.closest?.('cart-remove-button');
    if (remove) return intercept(event, remove, 0);
    const button = event.target.closest?.('quantity-input button[name="plus"], quantity-input button[name="minus"]');
    if (!button) return;
    const input = button.closest('quantity-input').querySelector('.quantity__input');
    if (!input) return;
    const step = Number(input.step) || 1;
    intercept(event, button, Math.max(0, Number(input.value) + (button.name === 'plus' ? step : -step)));
  }, true);

  window.addEventListener('change', event => {
    if (event.target.matches?.('.quantity__input')) intercept(event, event.target, Number(event.target.value));
  }, true);
})();
